import { useCallback, useState } from 'react';
import { logger } from '~/helpers/logger';

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<boolean>;

export const useCopyToClipboard = (): [CopiedValue, CopyFn] => {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy = useCallback(async (text: string) => {
    if (!navigator?.clipboard) {
      logger.warn('Clipboard not supported');
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      return true;
    } catch (error: unknown) {
      logger.warn('Copy failed', { error });
      setCopiedText(null);
      return false;
    }
  }, []);

  return [copiedText, copy];
};
